import { httpAnonymousRequest } from 'httpRequest'
import { CurrencyContract } from 'models'

const CURRENCY_PREFIX = '/currencies'

export const repository = {
    getCurrencies: () => {
        return httpAnonymousRequest.get<CurrencyContract[]>(CURRENCY_PREFIX)
    },
}
